(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-pro-quote"] && !Shopify.designMode) return;
  try {
    
  class AtelierQuoteRequest extends HTMLElement {
    connectedCallback() {
      if (this.active) return;
      this.active = true;
      this.abort = new AbortController();
      this.quantity = this.querySelector('[data-quote-quantity]');
      this.breakdown = this.querySelector('[data-quote-breakdown]');
      this.marking = this.querySelector('[data-quote-marking]');
      if (!this.quantity || !this.breakdown || !this.marking) return;
      try {
        this.config = JSON.parse(this.querySelector('[data-quote-data]').textContent);
      } catch {
        return;
      }
      this.edited = new Set();
      [this.quantity, this.breakdown, this.marking].forEach((input) => {
        if (input.value !== '') this.edited.add(input);
        const edited = () => {
          this.edited.add(input);
          this.clearStudioRequest();
          if (input === this.quantity) this.prefill();
        };
        input.addEventListener('input', edited, { signal: this.abort.signal });
        input.addEventListener('change', edited, { signal: this.abort.signal });
      });
      this.marking.addEventListener('change', () => this.syncEmbroidery(), { signal: this.abort.signal });
      this.addEventListener('atelier:studio-request', (event) => this.prepareStudioRequest(event.detail), { signal: this.abort.signal });
      document.addEventListener('atelier:studio-invalidated', (event) => {
        const detail = event.detail;
        if (!detail || String(detail.product_id) !== String(this.dataset.productId)) return;
        if (this.studioSnapshot?.project_id === detail.project_id && detail.revision <= this.studioSnapshot.revision) return;
        this.clearStudioRequest();
      }, { signal: this.abort.signal });
      this.picker = document.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`);
      this.variant = this.config.variant;
      this.prefill();
      this.syncEmbroidery();
      if (this.picker) {
        this.pickerRaw = this.picker.querySelector('script[type="application/json"]')?.textContent || '';
        this.picker.addEventListener('change', () => {
          this.variant = null;
          this.clearStudioRequest();
          if (!this.edited.has(this.breakdown)) this.breakdown.value = '';
        }, { capture: true, signal: this.abort.signal });
        this.observer = new MutationObserver(() => {
          if (String(this.picker.dataset.productId) !== String(this.dataset.productId)) return;
          const raw = this.picker.querySelector('script[type="application/json"]')?.textContent;
          if (!raw || raw === this.pickerRaw) return;
          try {
            const variant = JSON.parse(raw);
            this.pickerRaw = raw;
            this.variant = variant?.id ? variant : null;
            this.prefill();
          } catch {
            return;
          }
        });
        this.observer.observe(this.picker, { childList: true, characterData: true, subtree: true });
      }
      document.addEventListener('input', (event) => {
        if (event.target.matches?.('form[action*="/cart/add"] [name="quantity"]')) {
          this.clearStudioRequest();
          this.prefill();
        }
      }, { signal: this.abort.signal });
    }

    disconnectedCallback() {
      this.active = false;
      this.abort?.abort();
      this.observer?.disconnect();
    }

    productQuantity() {
      const form = [...document.querySelectorAll('form[action*="/cart/add"]')].find((candidate) => String(candidate.querySelector('[name="id"]')?.value) === String(this.variant?.id));
      const quantity = Number(form?.querySelector('[name="quantity"]')?.value);
      return Number.isSafeInteger(quantity) && quantity > 0 ? quantity : 1;
    }

    prefill(quantity = this.productQuantity()) {
      if (!this.variant?.id) return;
      if (!this.edited.has(this.quantity)) this.quantity.value = String(quantity);
      if (!this.edited.has(this.breakdown)) this.breakdown.value = `${this.variant.title}${this.variant.sku ? ` · ${this.variant.sku}` : ''} · ${this.quantity.value || quantity}`;
    }

    syncEmbroidery() {
      const embroidery = this.marking.value.startsWith('broderie_');
      this.querySelectorAll('[data-quote-embroidery]').forEach((field) => {
        field.hidden = !embroidery;
        field.querySelectorAll('input, select').forEach((input) => { input.disabled = !embroidery; });
      });
      this.querySelector('[data-quote-logo]').required = embroidery;
    }

    clearStudioRequest() {
      this.studioSnapshot = null;
      const data = this.querySelector('[data-quote-studio-data]');
      data.value = '';
      data.disabled = true;
      this.querySelector('[data-quote-studio-summary]').hidden = true;
    }

    prepareStudioRequest(detail) {
      if (!detail || String(detail.product_id) !== String(this.dataset.productId) || !detail.variant_id || !['A4', 'A3'].includes(detail.requested_format) || !Number.isSafeInteger(detail.quantity_intent) || detail.quantity_intent < 1) return;
      this.variant = { id: detail.variant_id, title: detail.variant_title, sku: detail.sku };
      this.prefill(detail.quantity_intent);
      const marking = detail.requested_format === 'A3' ? 'dtf_a3' : 'dtf_a4';
      if (!this.edited.has(this.marking)) this.marking.value = marking;
      this.syncEmbroidery();
      const breakdown = `${detail.variant_title}${detail.sku ? ` · ${detail.sku}` : ''} · ${detail.quantity_intent}`;
      if (Number(this.quantity.value) !== detail.quantity_intent || this.marking.value !== marking || this.breakdown.value.trim() !== breakdown) {
        this.clearStudioRequest();
        const summary = this.querySelector('[data-quote-studio-summary]');
        summary.textContent = this.config.labels.studio_conflict;
        summary.hidden = false;
        this.breakdown.focus({ preventScroll: true });
        return;
      }
      const data = this.querySelector('[data-quote-studio-data]');
      data.value = JSON.stringify(detail);
      data.disabled = false;
      this.studioSnapshot = { project_id: detail.project_id, revision: Number(detail.revision) || 0 };
      const summary = this.querySelector('[data-quote-studio-summary]');
      summary.textContent = `${this.config.labels.studio_summary} ${detail.variant_title} · ${detail.requested_format} · ${String(detail.project_id).slice(0, 12)}`;
      summary.hidden = false;
      this.breakdown.focus({ preventScroll: true });
    }
  }
  if (!customElements.get('atelier-quote-request')) customElements.define('atelier-quote-request', AtelierQuoteRequest);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
